<template>
    <div class="index-layout">
        <transition name="fade-transform" mode="out-in">
            <router-view/>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "index-layout",
        data() {
            return {}
        },
        created() {

        },
        mounted() {

        },
        methods: {},
    }
</script>

<style lang="scss">
    .index-layout {

    }
</style>